<template>
  <div class="billing-address">
    <div class="billing-address__container">
      <h3 class="billing-address__title">
        {{ $t('landingpage.checkout-page.billing-address.title') }}
      </h3>

      <div class="billing-address__intro">
        <p>{{ $t('landingpage.checkout-page.billing-address.intro') }}</p>
      </div>

      <form class="billing-address__form form-container">
        <div class="form-wrapper" :class="'col-span-full lg:col-span-6'">
          <div class="form-wrapper">
            <label for="first_name" class="field-label"
              >{{ $t('common.first_name') }}*</label
            >
            <input
              id="first-name"
              v-model="billingForm.billing_first_name"
              name="first-name"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_first_name"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_first_name"
            />
          </div>
        </div>

        <div class="form-wrapper" :class="'col-span-full lg:col-span-6'">
          <div class="form-wrapper">
            <label for="last_name" class="field-label"
              >{{ $t('common.last_name') }}*</label
            >
            <input
              id="last_name"
              v-model="billingForm.billing_last_name"
              name="last_name"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_last_name"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_last_name"
            />
          </div>
        </div>

        <div class="form-wrapper" :class="'col-span-full'">
          <div class="form-wrapper">
            <label for="email" class="field-label"
              >{{ $t('common.email') }}*</label
            >
            <input
              id="email"
              v-model="billingForm.billing_email"
              name="email"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_email"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_email"
            />
          </div>
        </div>

        <div class="form-wrapper" :class="'col-span-full'">
          <div class="form-wrapper">
            <label for="company" class="field-label"
              >{{ $t('common.company_name') }} ({{
                $t('common.optional')
              }})</label
            >
            <input
              id="company"
              v-model="billingForm.billing_company_name"
              name="company"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_company_name"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_company_name"
            />
          </div>
        </div>

        <div class="form-wrapper" :class="'col-span-full'">
          <div class="form-wrapper">
            <label for="vat" class="field-label"
              >{{
                $t('landingpage.checkout-page.billing.tax_number_vat_number')
              }}
              ({{ $t('common.optional') }})</label
            >
            <input
              id="vat"
              v-model="billingForm.billing_vat_number"
              name="vat"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_vat_number"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_vat_number"
            />
          </div>
        </div>

        <div class="form-wrapper" :class="'col-span-full'">
          <div class="form-wrapper">
            <label for="address_line_1" class="field-label"
              >{{
                $t('landingpage.checkout-page.billing.street_and_home')
              }}*</label
            >
            <input
              id="address_line_1"
              v-model="billingForm.billing_address"
              name="address_line_1"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_address"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_address"
            />
          </div>
        </div>

        <div class="form-wrapper col-span-full lg:col-span-4">
          <div class="form-wrapper">
            <label for="postal_code" class="field-label"
              >{{ $t('event.zip') }}*</label
            >
            <input
              id="postal_code"
              v-model="billingForm.billing_zip"
              name="postal_code"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_zip"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_zip"
            />
          </div>
        </div>
        <div class="form-wrapper col-span-full lg:col-span-8">
          <div class="form-wrapper">
            <label for="city" class="field-label"
              >{{ $t('common.city') }}*</label
            >
            <input
              id="city"
              v-model="billingForm.billing_city"
              name="city"
              type="text"
              class="form-element"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_city"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_city"
            />
          </div>
        </div>

        <div class="form-wrapper" :class="'col-span-full'">
          <div class="form-wrapper">
            <label for="country" class="field-label"
              >{{ $t('common.country') }}*</label
            >
            <select
              id="country"
              v-model="billingForm.billing_country"
              class="form-element"
            >
              <option value="">
                {{ $t('centerstage.ui.common.input.select-placeholder') }}
              </option>
              <template v-for="country in countries" :key="country.id">
                <option :value="country.id">{{ country.label }}</option>
              </template>
            </select>
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="errors.billing_country"
              class="form-error-message"
              role="alert"
              aria-live="assertive"
              v-html="errors.billing_country"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, inject } from 'vue'

const props = defineProps({
  billingData: { type: Object, default: () => ({}) },
  errors: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['update'])

const billingForm = ref({
  billing_first_name: null,
  billing_last_name: null,
  billing_email: null,
  billing_company_name: null,
  billing_address: null,
  billing_city: null,
  billing_zip: null,
  billing_phone: null,
  billing_vat: null,
  ...props.billingData,

  billing_country: props.billingData?.billing_country || 'de',
})

const countries = inject('countries')

watch(
  () => billingForm.value,
  () => {
    emit('update', billingForm.value)
  },
  { deep: true },
)
</script>
